import axios from "axios";


export const createStationLink = async (stationId, link) => {
    const res = await axios.post(`/api/v1/stations/${stationId}/links`, link);

    return res.data;
}

export const deleteStationLink = async (stationId, link_id) => {
    const res = await axios.delete(`/api/v1/stations/${stationId}/links/${link_id}`);

    return res.data;
}